import * as React from 'react';

// Optional how-to videos shown on the FAQ page. Drop the files in
// apps/manager/public/videos/ (or point VITE_HOWTO_VIDEO_BASE_URL at a
// hosted folder with the same file names); until a file exists each
// section shows a "coming soon" frame above its written walkthrough.
const VIDEO_BASE =
  (import.meta.env.VITE_HOWTO_VIDEO_BASE_URL as string | undefined) ??
  '/videos';
export const VIDEOS = {
  crmConnect: `${VIDEO_BASE}/connect-crm.mp4`,
  agencyProptree: `${VIDEO_BASE}/agency-proptree.mp4`,
  agentProptrees: `${VIDEO_BASE}/agent-proptrees.mp4`,
  forms: `${VIDEO_BASE}/forms.mp4`,
} as const;

// Video slot with graceful fallback while the asset doesn't exist yet.
export function HowToVideo({ src }: { src: string }) {
  const [failed, setFailed] = React.useState(false);
  if (failed) {
    return (
      <div className="flex aspect-video w-full items-center justify-center rounded-lg border border-dashed border-border bg-muted/40 px-6 text-center font-mono text-[11px] text-muted-foreground">
        How-to video coming soon — the written steps below cover it.
      </div>
    );
  }
  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      src={src}
      controls
      preload="metadata"
      className="aspect-video w-full rounded-lg border border-border bg-muted/40"
      onError={() => setFailed(true)}
    />
  );
}
